<!-- Verbatim legal text, including its original spelling. -->
<!-- cspell:ignore UNINTERUPTED MISTRANSCRIPTION Indemnitor Indemnitee -->
<div class="agreement-page">
  <article class="agreement" aria-labelledby="agreement-title">
    <h1 id="agreement-title">VIVE Client Service Agreement</h1>

    <p>
      This Service Agreement (&ldquo;<strong>Service Agreement</strong>&rdquo;)
      governs the provisions of Services by Vendor Information Verification
      Experts, LLC, 6190 Taylor Drive, Suite B; Flint, Michigan 48507; a
      Michigan limited liability company (&ldquo;<strong>VIVE</strong>&rdquo;)
      for the client set forth in the applicable Order Form
      (&ldquo;<strong>Client</strong>&rdquo;). VIVE and Client are collectively
      referred to herein as &ldquo;<strong>Parties</strong>&rdquo;.
    </p>

    <h2 class="part-heading">Recitals</h2>

    <p>
      VIVE gathers, provides and utilizes public record vendor data intended to
      be used for a permissible purpose via the VIVE cloud-based system to its
      Client base having a permissible purpose and use for such information.
    </p>
    <p>
      Client is an owner or manager of real property and desires to evaluate and
      manage its vendors and service providers (hereinafter
      &ldquo;<strong>Vendors</strong>&rdquo;) as contained in Client&rsquo;s
      &ldquo;<strong>Vendor List</strong>&rdquo; within the VIVE database to
      determine whether, at the time Vendor information is collected, those
      Vendors meet certain standards relating to licensing, insurance
      compliance, financial character and other related standards that Client
      deems material to its decision to hire or engage Vendors;
    </p>
    <p>
      NOW, THEREFORE, in consideration of the foregoing Recitals the Parties
      desire to agree as follows:
    </p>

    <h2 class="part-heading">Agreement</h2>

    <section aria-labelledby="section-a">
      <h3 id="section-a">A. Services Provided</h3>
      <p>
        VIVE will collect information pertaining to Client&rsquo;s existing and
        prospective Vendors as directed by Client on the Order Form, attached
        hereto and by this reference made a part hereof, to ensure that such
        Vendors meet the standards specified by Client to be deemed
        &ldquo;compliant&rdquo; and to allow Client convenient access to the
        information gathered (&ldquo;the <strong>Services</strong>&rdquo;).
      </p>
      <p>
        VIVE will clearly list the compliant and non-compliant Vendors on the
        <a href="https://www.getvived.com/" target="_blank" rel="noopener"
          >www.getvived.com</a
        >
        website and will provide to Client the vendor information pursuant to
        the Services selected by Client as indicated on the Order Form. VIVE
        will have no obligation to provide services or information beyond what
        is specified in the Order Form, except as mutually agreed in writing by
        the Parties.
      </p>
    </section>

    <h2 class="part-heading">Use of Services</h2>

    <section aria-labelledby="section-b">
      <h3 id="section-b">B. Exclusivity</h3>
      <p>
        Client will exclusively utilize only VIVE for screening and evaluation
        of all existing and prospective vendors and service providers for all
        properties managed and/or owned by Client (the &ldquo;<strong
          >Designated Properties</strong
        >&rdquo;), and will require all such vendors and service providers to
        provide to VIVE the requested information per the Order Form. Client
        shall provide VIVE with an accurate list of the Designated Properties
        during the online registration process for the Services and shall update
        that list within [ten(10) business days] of any change.
      </p>
    </section>

    <section aria-labelledby="section-c">
      <h3 id="section-c">C. Compensation</h3>
      <p>
        Client agrees to the initial and annual renewal
        <strong>Client Fees</strong> at the rates listed on the Order Form and
        will require its Vendors to pay VIVE the initial and annual renewal
        rates set forth in the Column marked <strong>Vendor Fees</strong> in the
        Order Form. VIVE reserves the right to increase its Vendor Fees annually
        by no more than $10 under the applicable Order Form effective on the
        anniversary of the Go Live Date (defined in the Order Form) by providing
        at least sixty (60) days advance written notice to Client prior to the
        anniversary of the Go Live Date. Upon receiving written notice from VIVE
        that a Vendor has failed to make payments due to VIVE, Client will stop
        working with such Vendor within thirty days of such notice unless the
        Vendor cures the deficiency by making full payment to VIVE.
      </p>
      <p>
        VIVE shall pay Client the annual
        <strong>Client Compensation</strong> described in the Order Form during
        the term of this Service Agreement.
      </p>
    </section>

    <section aria-labelledby="section-d">
      <h3 id="section-d">D. Confidentiality and Usage Rights</h3>
      <p>
        Each Party acknowledges that it may receive access through this
        Agreement to information that is treated as confidential and proprietary
        by the other Party, in any form or medium (collectively, the
        &ldquo;<strong>Confidential Information</strong>&rdquo;).
      </p>
      <p>
        The following will be considered the Confidential Information of each
        Party:
      </p>
      <ul>
        <li>The terms of this Service Agreement</li>
      </ul>
      <p>
        The following will be considered Client Confidential Information and
        will be owned exclusively by Client:
      </p>
      <ul>
        <li>
          Information received from Vendors in connection with this Service
          Agreement (&ldquo;<strong>Vendor Information</strong>&rdquo;)
        </li>
        <li>
          All confidential or proprietary data and information which Client
          enter into the VIVE Application
        </li>
        <li>
          The Designated Properties and information related to their management
          by Client.
        </li>
      </ul>
      <p>
        The following will be considered VIVE Confidential Information and will
        be owned exclusively VIVE:
      </p>
      <ul>
        <li>
          All technical, developmental, operating, computer system, software,
          performance cost, know-how and process information of which it may
          become aware through VIVE, the use of VIVE&rsquo;s browser-based
          portal (the &ldquo;<strong>VIVE Application</strong>&rdquo;) and all
          ideas and know-how developed by VIVE or in connection with the VIVE
          Application, including its trade secrets.
        </li>
      </ul>
      <p>
        Each Party agrees to (a) maintain as confidential the Confidential
        Information of the other Party and all Vendor Information, (b) only
        share such information with its employees or suppliers who have a need
        to know and have agreed to confidentiality requirement at least as
        protective as this Service Agreement and (c) not use such information
        except in connection with its rights and obligations under this Service
        Agreement. These confidentiality obligations will survive expiration or
        termination of this Service Agreement. Upon the termination or
        expiration of this Service Agreement, each Party will return to the
        other Party such other Party&rsquo;s Confidential Information.
      </p>
      <p>
        Confidential Information shall not include information that: (a) is or
        becomes generally available to the public other than through your breach
        of this Service Agreement; (b) is communicated to a Party by a third
        party that had no confidentiality obligations with respect to such
        information, or (c) is developed by a party without any reference to any
        Confidential Information of the other party. Nothing herein shall: be
        construed to prevent disclosure of Confidential Information as may be
        required by applicable law or regulation, or pursuant to the valid order
        of a court of competent jurisdiction or an authorized government agency,
        provided that the disclosure does not exceed the extent of disclosure
        required by such law, regulation, or order.
      </p>
      <p>
        Each Party acknowledges that its breach of the confidentiality
        provisions in this Section would cause irreparable harm to the other
        Party&rsquo;s business and that any remedy at law would be inadequate.
        In the event of a breach of this Section, the non-breaching Party will
        be entitled to injunctive relief, without first having to demonstrate
        irreparable harm and without posting bond (to the extent permitted by
        applicable law), in addition to any other available remedies, including
        damages.
      </p>
      <p>
        Client hereby grants to VIVE a non-exclusive, royalty-free license to
        use any materials uploaded to the VIVE Application by or on behalf of
        Client and any feedback regarding the VIVE Application for the purposes
        of (i) VIVE performing its obligations under this Service Agreement and
        (ii) improving and developing new services and features uses aggregated
        data that does not identify the Client.
      </p>
    </section>

    <section aria-labelledby="section-e">
      <h3 id="section-e">
        E. Representations, Warranties and Disclaimers of VIVE; LIMITATIONS OF
        LIABILITY
      </h3>
      <p>
        VIVE will use commercially reasonable efforts to provide the Services in
        a timely and professional manner and to use industry standard procedures
        for presenting information that is accurate and reliable. Client
        acknowledges that VIVE collects information from third party sources
        (including Vendors, credit reporting services, as well as state and
        federal agencies) and that VIVE does not guarantee the accuracy of any
        information received from a third party. VIVE has no obligation to
        monitor or correct any information that may change after the date on
        which it was collected. Client assumes all responsibility for its use of
        the Services and any information obtained through the Services.
      </p>
      <p>
        To the maximum extent allowed under applicable law, VIVE will not be
        liable for any claim, injury or damage (whether direct, indirect or
        consequential) (a) arising in connection its furnishing of the Services,
        (b) resulting from Client&rsquo;s use of the Services or (c) based on
        any acts or omissions of a third party, such as any Vendor or resident
        of any Designated Properties.
      </p>
      <p>
        EXCEPT AS OTHERWISE EXPRESSLY PROVIDED HEREIN, VIVE MAKES NO, AND HEREBY
        DISCLAIMS ANY AND ALL, WARRANTIES WHETHER EXPRESS, IMPLIED, OR STATUTORY
        RELATED TO THE SUBJECT MATTER OF THIS SERVICE AGREEMENT, INCLUDING ANY
        IMPLIED WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
        VIVE MAKES NO GUARANTEES THAT THE SERVICES WILL BE ERROR-FREE OR
        UNINTERUPTED.
      </p>
      <p>
        TO THE FULL EXTENT PERMITTED BY APPLICABLE LAW, (1) VIVE WILL NOT BE
        LIABLE FOR ANY LOSS OF PROFITS OR ANY INDIRECT, INCIDENTAL, PUNITIVE,
        SPECIAL OR CONSEQUENTIAL DAMAGES ARISING OUT OF OR IN CONNECTION WITH
        THIS AGREEMENT AND (2) EXCEPT AS PROVIDED IN THE NEXT PARAGRAPH,
        VIVE&rsquo;S AGGREGATE LIABILITY FOR ANY DAMAGES ARISING OUT OF THIS
        SERVICE AGREEMENT WILL NOT EXCEED THE AMOUNT PAID BY CUSTOMER AND
        VENDORS TO VIVE IN CONNECTION WITH THIS SERVICE AGREEMENT IN THE TWELVE
        (12) MONTHS PRECEDING.
      </p>
      <p>
        THE LIABILITY LIMIT IN THE PRECEDING PARAGRAPH DO NOT APPLY TO
        VIVE&rsquo;S (a) GROSS NEGLIGENCE OR WILLFUL MISCONDUCT, (b) BREACH OF
        CONFIDENTIALITY PROVISIONS IN THIS SERVICE AGREEMENT, OR (c)
        VIVE&rsquo;S INDEMNIFICATION OBLIGATIONS UNDER THIS SERVICE AGREEMENT.
        VIVE&rsquo;S AGGREGATE LIABILITY FOR ANY DAMAGES ARISING OUT (b) OR (c)
        IN THE PRECEDING SENTENCE WILL NOT EXCEED FIFTY THOUSAND DOLLARS
        ($50,000). IN THE EVENT THAT VIVE&rsquo;S NEGLIGENT ACTIONS (E.G.,
        MISTRANSCRIPTION ERRORS) RESULT IN CLIENT RECEIVING INACCURATE
        INFORMATION THAT DIRECTLY AND PROXIMATELY CAUSES A LOSS TO CLIENT, VIVE
        WILL REIMBURSE CLIENT FOR SUCH DIRECT, DOCUMENTED LOSSES UP TO THE
        AMOUNT AVAILABLE TO VIVE UNDER ANY APPLICABLE PROFESSIONAL LIABILITY
        INSURANCE POLICY, AT THE THEN-CURRENT LIMIT FOR A SINGLE OCCURRENCE.
      </p>
    </section>

    <section aria-labelledby="section-f">
      <h3 id="section-f">
        F. Representations, Warranties and Covenants of Client
      </h3>
      <p>
        Client hereby represents, warrants, covenants and agrees that the Client
        has and will maintain and adhere to a policy regarding the use of Vendor
        Information to ensure that the Vendor Information is used fairly and in
        compliance with all applicable laws, rules, regulations and this Service
        Agreement. Client also agrees to comply with all terms and conditions
        applicable to the use of the VIVE Application, which are hereby
        incorporated by reference.
      </p>
    </section>

    <section aria-labelledby="section-g">
      <h3 id="section-g">G. Indemnification</h3>
      <p>
        Each Party (an &ldquo;<strong>Indemnitor</strong>&rdquo;) hereby agrees
        to defend, indemnify and hold harmless the other Party (and
        &ldquo;<strong>Indemnitee</strong>&rdquo;), its officers, directors,
        employees, stakeholders, agents and representatives from and against any
        and all suits, actions, losses, damages, claims, demands, fines,
        penalties or liability of any character, type, or description, including
        any and all expenses of litigation, court costs and attorney fees,
        arising out of, or occasioned by, the Indemnitor&rsquo;s gross
        negligence.
      </p>
      <p>
        The obligations of Section D, E, F and G will survive the termination of
        this Service Agreement. The remedies contained in Section D are
        cumulative with other remedies under this Service Agreement.
      </p>
    </section>

    <section aria-labelledby="section-h">
      <h3 id="section-h">H. Term</h3>
      <p>
        The term of this Service Agreement will be one (1) year and will renew
        automatically for successive one-year periods unless notice of a desire
        to terminate is given by Client at least thirty (30) days prior to the
        next annual renewal date. Either party may terminate this Service
        Agreement for cause upon thirty (30) days&rsquo; written notice. Client
        may terminate this Service Agreement for convenience upon sixty (60)
        days&rsquo; written notice.
      </p>
    </section>

    <section aria-labelledby="section-i">
      <h3 id="section-i">I. Miscellaneous</h3>
      <p>
        VIVE has the sole right to determine, develop and modify the
        programming, data and equipment used to provide the Services. Client
        will remain responsible for all equipment (computers, internet
        connections, etc.) needed to access the VIVE Application.
      </p>
      <p>
        This Service Agreement is governed by the laws of the State of New York
        without regard to conflicts of law principles. Client submits to the
        jurisdiction of state and federal courts in North Carolina in any
        dispute concerning this Service Agreement and waives any claim that
        another forum may be more appropriate or convenient.
      </p>
      <p>
        This Service Agreement shall be binding upon the parties and their
        respective heirs, representatives, successors and assigns, but no party
        may assign any benefit or delegate any duty under this Service
        Agreement, either voluntarily or by operation of law, without the prior
        written consent of the other party. Notwithstanding the foregoing, VIVE
        may assign or transfer this Service Agreement through merger or sale of
        substantially all its assets. Written notice of the assignment will be
        given to Client promptly following an assignment or transfer.
      </p>
      <p>
        In the event of any litigation to enforce this Service Agreement, the
        prevailing party shall be entitled to recover its reasonable
        attorneys&rsquo; fees and costs incurred in such suit, including at
        trial, on appeal, or in any insolvency or bankruptcy proceeding or
        appeal thereof. The amount of such fees and expenses shall be fixed by
        the court.
      </p>
      <p>
        If any part of this Service Agreement shall be found to be
        unenforceable, invalid, or illegal, or violate public policy, that part
        shall be severed from the remainder of this Service Agreement and the
        remaining terms of this Service Agreement shall continue in full force
        and effect unless the removal of the invalid or unenforceable part would
        substantially defeat the basic intent, purposes and spirit of the
        Service Agreement.
      </p>
      <p>
        Any notice under this Service Agreement will be effective upon delivery
        in person, by email or by facsimile transmission or, if sent only by
        mail, three days following mailing by registered or certified mail with
        proper address and postage prepaid. All additions or modifications to
        this Service Agreement must be in writing and executed by both parties.
      </p>
      <p>
        This Service Agreement constitutes the entire agreement among the
        parties with respect to the subject matter and may be modified only in
        writing signed by authorized persons. Failure to enforce any provision
        of this Service Agreement in one instance shall not constitute a waiver
        of the right to enforce the provision in a subsequent instance or waiver
        of the provision itself.
      </p>
      <p>
        Each individual signing this Service Agreement for a party individually
        warrants that he/she is authorized to do so, and that this Service
        Agreement is binding upon the party for whom the individual signs.
      </p>
      <p>
        No party shall be responsible for any delay or failure to perform caused
        by adverse weather, casualty or other cause reasonably beyond its
        control, provided that this clause shall not excuse any party from
        failure to pay an amount payable hereunder on time.
      </p>
      <p>
        This Service Agreement may be executed in one or more counterparts, each
        of which shall be deemed an original, and all of which together shall
        constitute one and the same original Service Agreement. A signature to
        this Service Agreement tendered via electronic delivery as an electronic
        file (e.g. portable document format) shall constitute an original
        signature and will bind the signing Party as if it was an original
        signature.
      </p>
      <p>
        Actual, reasonable out of pocket expenses (e.g., for travel, lodging,
        and meals) incurred by VIVE in connection with any on-site training,
        consulting or other mutually-agreed services for Client will be billed
        to Client for reimbursement.
      </p>
    </section>
  </article>
</div>
